import React, {useEffect, useState} from "react";
import headerBg from "./assets/header_bg.jpg";
import mobileHeaderBg from "./assets/mobile_header_bg.jpg";
import autonomous_machine from "./assets/autonomous_machine.svg";
import another_autonomous_machine from "./assets/another_autonomous_machine.png";
import mobile_logo from "./assets/mobile_logo.svg";
import mobile_logo_menu from "./assets/mobile_logo_menu.svg";
export default function Navigation() {
    // ────────────────────────────────────────────────────────
    // State
    // ────────────────────────────────────────────────────────
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    // Detect breakpoint so we can swap background images
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768); // match Tailwind `md:`
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const bgImage = isMobile ? mobileHeaderBg : headerBg;

    // Navigation labels & anchors
    const items = [
        {label: "What we do", href: "#home"},
        {label: "Our Technology", href: "#features"},
        {label: "About", href: "#about"},
        {label: "Contact", href: "#contact"},
    ];

    // ────────────────────────────────────────────────────────
    // Render
    // ────────────────────────────────────────────────────────
    return (
        <nav
            className="relative px-4 py-6 md:px-0 md:py-0 w-full mx-auto max-w-[101.25rem] min-h-[50rem] sm:min-h-[55rem] md:min-h-[40.5rem]  xl:min-h-[90vh] bg-cover backdrop-blur-lg z-50"
            style={{backgroundImage: `url(${bgImage})`}}
        >
            <div className="flex items-center">
                {/* Logo */}
                {/* Desktop Logo (hidden on mobile) */}
                <span className="hidden sm:block sm:absolute sm:left-0 sm:top-0 text-3xl sm:text-4xl sm:font-bold text-black w-fit">
  <span className="block w-fit bg-yellow px-2">Autonomous</span>
  <span className="block w-fit bg-yellow px-2">Machines</span>
</span>

                {/* Mobile Logo (visible only on mobile) */}
                <span className="sm:hidden absolute top-6 left-8">
  <img src={mobile_logo} alt="Mobile Logo" className="w-full h-full" />
</span>
                <div className="md:hidden absolute top-0   left-0 w-full h-full -z-10 "
                     style={{background: "linear-gradient(180deg, #E8E8F2 0%, rgba(232, 232, 242, 0.00) 100%)"}}></div>

                {/* Desktop menu */}
                <div className="hidden md:flex gap-0 bg-white ml-auto">
                    {items.map(({label, href}) => (
                        <a
                            key={label}
                            href={href}
                            className="px-4 py-2 hover:bg-black text-black hover:text-white transition-colors"
                        >
                            {label}
                        </a>
                    ))}
                </div>

                {/* Mobile menu button */}
                <button
                    className="text-[1.25rem] md:hidden ml-auto px-4 py-2 bg-black text-white focus:outline-none"
                    onClick={() => setIsMenuOpen(true)}
                    aria-label="Open menu"
                >
                    Menu
                </button>

                {/* Decorative right image */}


                <div className=" absolute bottom-[100px] -z-10 right-0 w-[16rem] md:w-[21rem] md:w-[30.6875rem]  xl:w-[37.6875rem]">
                    <img
                        src={another_autonomous_machine}
                        alt="render of an autonomous machine"
                        className="select-none"
                        draggable={false}
                    />
                </div>

                {/* Hero text block */}
                <div id="yellow_block"
                    className="top-[7rem] sm:top-40 right-0  md:top-auto md:right-auto md:left-0 md:bottom-0 pb-10 absolute md:bg-yellow text-black md:max-w-[25rem] xl:max-w-[42.5rem] pt-4 px-10">
                    <h1 className="text-[3rem] sm:text-[2rem]  xl:text-[4rem] max-w-[35.375rem] leading-none mt-4">
                        Autonomous. Modular. Scalable.
                    </h1>
                    <p className="text-[1.5rem] xl:text-[2rem] leading-tight max-w-[32.25rem] mb-8 mt-4">
                        Build safer, faster, and more efficiently.
                    </p>
                    <a
                        href="#contact"
                        className="px-4 text-lg py-3 hover:bg-black bg-white text-black hover:text-white transition-colors"
                    >
                        Let&apos;s Talk
                    </a>
                </div>
            </div>


            <div
                className="absolute bottom-[-30px]  w-[20rem] sm:w-[25rem] md:w-[28.6875rem] lg:w-[37.6875rem] left-5 md:bottom-[-100px] md:left-1/2 md:transform md:-translate-x-1/2 z-40">
                <img src={autonomous_machine} alt="autonomous machine" className="select-none" draggable={false}/>
            </div>

            {/* Full‑screen mobile menu */}
            {isMenuOpen && (
                <div className=" fixed inset-0 bg-yellow items-left justify-center h-screen z-[100] p-10">

                    {/* Desktop Text Logo (hidden on mobile) */}
                    <span className="hidden sm:absolute sm:top-6 sm:left-7 text-3xl md:text-4xl font-bold text-black w-fit sm:block">
  <span className="block w-fit bg-black text-yellow px-2">Autonomous</span>
  <span className="block w-fit bg-black text-yellow px-2">Machines</span>
</span>

                    {/* Mobile SVG Logo (only on mobile) */}
                    <span className="sm:hidden absolute top-6 left-8">
  <img src={mobile_logo_menu} alt="Mobile Logo" className="w-full h-full" />
</span>
                    <div className="flex flex-col mt-40">
                        {items.map(({label, href}) => (
                            <a
                                key={label}
                                href={href}
                                onClick={() => setIsMenuOpen(false)}
                                className="text-3xl w-fit font-semibold bg-white text-black text-black hover:text-white hover:bg-black px-6 py-4 transition-colors"
                            >
                                {label}
                            </a>
                        ))}
                    </div>

                    <div
                        className="text-xl absolute bottom-20 left-1/2 transform -translate-x-1/2 underline underline-offset-2">
                        <a className="whitespace-nowrap" href="mailto:contact@autonomous-machines.com">
                            contact@autonomous-machines.com
                        </a>
                    </div>
                    {/* Close */}
                    <button
                        className="text-[1.25rem] absolute top-6 right-4 px-4 py-2 bg-black text-white"
                        onClick={() => setIsMenuOpen(false)}
                        aria-label="Close menu"
                    >
                        Close
                    </button>
                </div>
            )}
        </nav>
    );
}
